<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row justify="space-between" no-gutters align="center">
        <v-col cols="12" md="5">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1">Publicidades para o Instagram</div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" v-for="(item, index) in dados" :key="index">
          <v-card @click="openDialog(item)" class="cursor-pointer px-1 py-1">
            <div class="imagem_area">
              <div class="imagem_area_bg" :style="'background-image: url(' + item.pub_imagem + ')'">
              </div>
              <img :src="item.pub_imagem" :alt="item.pub_nome">
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog
      v-model="dialogOpen"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{instagram.pub_nome}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-card class="px-2 py-2 mb-3">
          <div class="text-center">
            <img :src="instagram.pub_imagem" alt="Imagem">
          </div>
        </v-card>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            @click="downloadImagem()"
            :loading="salvando"
            :disabled="salvando || !user.usu_permissao_publicidades"
          >
            Baixar pacote <v-icon>download</v-icon>
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      user: null,
      loading: true,
      salvando: false,
      dialogOpen: false,
      search: '',
      modulos: [],
      dados: [],
      instagram: {
        pub_nome: '',
        pub_imagem: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.loadPhotos()
      this.loading = false
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    async loadPhotos () {
      this.loading = true
      await Api.get('publicidades/geral')
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.length > 0) {
              res.data.map(item => {
                if (item.pub_pacote) {
                  info.push({
                    pub_id: item.pub_id,
                    pub_nome: item.pub_nome,
                    pub_imagem: item.pub_imagem,
                    uuid_pub_id: item.uuid_pub_id
                  })
                }
              })
            }
            this.dados = info
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os instagrams!',
            color: 'error'
          })
          console.log(err)
        })
    },
    downloadImagem () {
      this.salvando = true
      Api.get(`publicidades/download/${this.instagram.uuid_pub_id}`)
        .then((res) => {
          console.log(res.data)
          if (res.data) {
            this.download(res.data.pub_pacote)
          }
          this.salvando = false
        })
        .catch(error => {
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
          this.salvando = false
        })
    },
    async download (url) {
      let a = document.createElement('a')
      a.href = url
      a.target = '_blank'
      a.download = this.instagram.pub_nome
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(url)
    },
    openDialog (item) {
      this.instagram = JSON.parse(JSON.stringify(item))
      this.dialogOpen = true
    },
    closeDialog () {
      this.dialogOpen = false
      setTimeout(() => {
        this.instagram = {
          pub_nome: '',
          pub_imagem: ''
        }
      }, 200)
    }
  },
  created () {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.imagem_area {
  align-items: center;
  display: flex;
  height: 250px;
  justify-content: center;
  position: relative;
  transition: all 0.3s;
  width: 100%;
  &_bg {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    filter: blur(5px);
    height: 250px;
    position: absolute;
    transition: all 0.3s;
    width: 100%;
  }
  img {
    margin: 0 auto;
    max-height: 250px;
    max-width: 100%;
    position: relative;
    transition: all 0.3s;
    @media screen and (max-width: 991px) {
      max-height: 150px;
    }
  }
  &:hover :not(:hover) {
    opacity: 0.6;
    transition: all 0.3s;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/InstagramLista.vue